import { VideoBackdrop } from './VideoBackdrop.jsx';

export function HeroVideo() {
  return <VideoBackdrop src="/assets/video/hero-loop.mp4" className="hero-video" />;
}
